<template>
  <p class="c-error-text">
    <slot></slot>
  </p>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.c-error-text {
  color: $error;
  font-size: px(14);
  margin-top: rem(8);
}
</style>
